import * as React from "react";
const SvgFiBrandsJs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M16.122 18.75a2.46 2.46 0 0 0 2.225 1.37c.934 0 1.531-.467 1.531-1.113 0-.773-.613-1.047-1.642-1.5l-.564-.242c-1.627-.693-2.708-1.562-2.708-3.4a3.014 3.014 0 0 1 3.3-2.979 3.33 3.33 0 0 1 3.21 1.814l-1.756 1.127a1.53 1.53 0 0 0-1.45-.966.98.98 0 0 0-1.08.966c0 .677.418.951 1.386 1.37l.564.241c1.916.822 3 1.66 3 3.543 0 2.031-1.595 3.143-3.737 3.143a4.33 4.33 0 0 1-4.11-2.306zm-7.967.2c.354.628.677 1.16 1.451 1.16.741 0 1.21-.29 1.21-1.418V11.02h2.254v7.7a3.062 3.062 0 0 1-3.368 3.4 3.5 3.5 0 0 1-3.383-2.06z"
    />
  </svg>
);
export default SvgFiBrandsJs;
